import React from 'react';
import { Shield, Target, Zap, Heart } from 'lucide-react';
import { BenefitCard } from '../../components/BenefitCard';
export function MartialArtsNearMeBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2439">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2440">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2441">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2442">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2443">
          <BenefitCard icon={Shield} title="Self-Defense Skills" description="Learn practical fundamentals to protect yourself and build confidence." data-id="element-2444" />
          <BenefitCard icon={Target} title="Mental Discipline" description="Develop focus and resilience through structured martial arts training." data-id="element-2445" />
          <BenefitCard icon={Zap} title="Physical Fitness" description="A dynamic, full-body workout that improves strength and agility." data-id="element-2446" />
          <BenefitCard icon={Heart} title="Family-Friendly" description="A welcoming environment for students of all ages and experience levels." data-id="element-2447" />
        </div>
      </div>
    </section>;
}